<template>
    <div class="navigation-mobile-body" role="region">
        <div class="navigation-mobile-body__header">
            <div v-if="currentLevel.header"
                 class="navigation-mobile-body__item navigation-mobile-body__item--backlink">
                <span class="navigation-mobile-body__item-inner" @click="backToLevel">
                    <div class="navigation-mobile-body__arrow-icon">
                        <z-icon
                            class="navigation-mobile-body__arrow navigation-mobile-body__arrow--left"
                            :name="icons.backlink"
                            width="16"
                            height="16"
                            dir="left"

                        />
                    </div>
                    <a href="javascript:void(0);">
                        <span>
                            {{ currentLevel.header }}
                        </span>
                    </a>
                </span>
            </div>
        </div>
        <div class="navigation-mobile-body__submenu">
            <ul class="navigation-mobile-body__list" role="menu">
                <li v-if="currentLevel.parent" class="navigation-mobile-body__item navigation-mobile-body__item--parent" role="none">
                    <component
                        :is="currentLevel.parent.link ? 'a' : 'span'"
                        :href="currentLevel.parent.link"
                        class="navigation-mobile-body__item-inner"
                        :class="{'navigation-mobile-body__item-inner--redirect' : currentLevel.parent.pageParams.redirect}"
                    >
                        <span>
                            {{ currentLevel.parent.name }}
                        </span>
                        <div  v-if="!currentLevel.parent.pageParams.redirect" class="navigation-mobile-body__arrow-icon">
                            <z-icon
                                class="navigation-mobile-body__arrow navigation-mobile-body__arrow--right"
                                :name="icons.link"
                                width="12"
                                height="12"
                                dir="right"
                            />
                        </div>
                    </component>
                </li>
                <li class="navigation-mobile-body__item"
                    v-for="(item, index) in currentLevel.items"
                    :key="index"
                    :class="[
                        {'is-active': checkActiveState(item)},
                        {'navigation-mobile-body__item--submenu': levelCount !== 0},
                        {'navigation-mobile-body__item--with-accordion': levelCount !== 0 && item.items?.length}
                    ]"
                    role="none"
                >
                    <template v-if="item.items?.length">
                        <template v-if="showAlternateLink">
                            <accordion-link :arrow-icon="icons.link" :item-parent="item">
                                <span v-html="item.name"/>
                            </accordion-link>
                        </template>
                        <span v-else class="navigation-mobile-body__item-inner" @click="changeLevel(item, header)">
                            <span v-html="item.name"/>
                            <z-icon
                                class="navigation-mobile-body__arrow navigation-mobile-body__arrow--right"
                                :name="icons.link"
                                width="20"
                                height="20"
                                dir="right"
                            />
                        </span>
                    </template>
                    <a v-else
                       class="navigation-mobile-body__item-inner"
                       :href="item.link"
                       :title="item.name"
                       :target="item.params && item.params.BLANK ? '_blank' : null"
                       role="menuitem"
                    >
                        <span>
                            <span v-html="item.name"/>
                            <z-icon
                                class="navigation-mobile-body__external-icon"
                                v-if="item.params.EXTERNAL"
                                :name="icons.external"
                            />
                        </span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import AccordionLink from './AccordionLink.vue'
import { localize } from '@/utils/i18n'
// import { mockedData } from '../mockedData'

export default {
    name: 'navigation-mobile-body',
    components: {
        AccordionLink
    },
    props: {
        icons: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            text: {
                mainMenu: localize({
                    ru: 'Главное меню',
                    en: 'Main menu',
                    cn: '主菜单'
                })
            },
            levelMap: [],
            levelCount: 0,
            currentLevel: {
                items: [],
                header: null,
                parent: null
            }
        }
    },
    mounted () {
        this.levelMap.push({
            items: this.linksList,
            header: null,
            parent: null
        })
        this.updateCurrentLevel()
    },
    computed: {
        linksList() {
            const top = this.$root.app?.components?.navigation?.top || []
            const header = this.$root.app?.components?.navigation?.header || []
            return [...top, ...header]
        },
        header () {
            if (this.currentLevel.parent === null) {
                return this.text.mainMenu
            }
            return this.currentLevel.parent.name
        },
        maxLevels () {
            const collection = new Set()
            this.levelsCounter(this.linksList, collection)
            return Math.max(...collection)
        },
        showAlternateLink () {
            return this.levelCount === this.maxLevels - 3
        }
    },
    methods: {
        changeLevel (item, header) {
            this.levelCount = item.level
            this.levelMap.push(this.adaptDataToLevel(item, header))
            this.updateCurrentLevel()
        },
        backToLevel () {
            this.levelCount -= 1
            this.levelMap.splice(this.levelMap.length - 1, 1)
            this.updateCurrentLevel()
        },
        checkActiveState (item) {
            if (item.active === true) return true

            for (let i = 0; i < item.items?.length; i++) {
                if (item.items[i].active === true) return true
            }

            return false
        },
        // levelsCounter считает рекрсивно сколько у нас всего уровней
        levelsCounter (parent, collection) {
            parent.forEach((item) => {
                collection.add(item.level)
                item.items?.length > 0 && (this.levelsCounter(item.items, collection))
            })
        },
        adaptDataToLevel (data, header) {
            return {
                items: data.items,
                header: header,
                parent: data
            }
        },
        /* В связи с тем что watch и computed не могут отследить изменение
        массива пришлось делать отдельный метод для обновления текущего уровня
        вложенности */
        updateCurrentLevel () {
            this.currentLevel = this.levelMap[this.levelMap.length - 1]
        }
    }
}
</script>

<style lang="scss">
@import "../vars";

.navigation-mobile-body {
    width: 100%;
    flex-grow: 1;
    padding-top: 1rem;
    padding-bottom: 2rem;

    &__arrow-icon {
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        color: currentColor;
        border-radius: 50%;
        transition: color $transition, border-color $transition;

        path {
            transition: fill $transition;
            fill: currentColor;
        }
    }

    &__list {
        padding: 0;
        margin: 0;

        &--top {
            padding: 1rem 0;
        }
    }

    &__item {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        line-height: 1.5rem;
        @include typo-level(XL);
        padding: 0 var(--spacer-s);

        .navigation-mobile-body__item-inner {
            color: $nav-link-color
        }

        &:has(+ .navigation-mobile-body__item.is-active) {
            .navigation-mobile-body__item-inner {
                border-bottom-width: 0;
            }
        }

        &--with-accordion {

            .accordion-link__header{
                padding: 0;
            }

            .accordion-link__item-inner--active{
                padding: var(--spacer-s) calc(var(--spacer-xs) + 16px);
            }

            .accordion-link__body-list{
                margin: 0;
                padding-right: var(--spacer-s);
                padding-left: var(--spacer-s);
            }

            &:has(+ .navigation-mobile-body__item.is-active) {
                .accordion-link__item-inner,
                .accordion-link__body-list {
                    border-bottom-width: 0;
                }
            }
        }

        &.is-active {
            padding: 0;

            .navigation-mobile-body__item-inner {
                color: $nav-link-color-active;
                background: rgba(255, 255, 255, 0.10);
                border-width: 1px 0 1px 0;
                padding: var(--spacer-s);

                .z-icon {
                    path {
                        fill: $nav-link-color-active;
                    }
                }
            }
        }

        &--backlink,
        &--parent {
            padding: var(--spacer-s);

            .navigation-mobile-body__item-inner {
                flex: 0 0 auto;
                gap: 22px;
                justify-content: flex-start;
                font-weight: 600;
                border: none;
                padding: 0;
            }
        }

        &--backlink {
            margin-bottom: var(--spacer-s);

            .navigation-mobile-body__item-inner {
                color: var(--color-link-light-default);
                text-transform: none;
            }
        }

        &--parent {

            .navigation-mobile-body__item-inner {
                font-size: 1.375rem;
                color: $nav-parent-link-color;
            }

            .navigation-mobile-body__arrow-icon {
                width: 24px;
                height: 24px;
            }
        }
    }

    &__item-inner {
        flex: 0 0 100%;
        max-width: 100%;
        font-weight: 700;
        font-size: 20px;
        padding: var(--spacer-s) 0;
        color: $nav-link-color;
        border-width: 0 0 1px 0;
        border-style: solid;
        border-color: rgba(255, 255, 255, 0.30);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        transition: color $transition, background $transition;

        .z-icon {
            path {
                fill: $nav-link-color;
            }
        }

        .navigation-mobile-body__external-icon {
            path {
                fill: $nav-external-icon-color;
            }
        }

        &--redirect {
            cursor: auto;
        }
    }
}
</style>
